import { render, staticRenderFns } from "./FTextarea.vue?vue&type=template&id=160b0b2c&"
import script from "./FTextarea.vue?vue&type=script&lang=js&"
export * from "./FTextarea.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "FTextarea.vue"
export default component.exports